<template>
  <el-card class="box-card bg">
    <div class="clearfix">
      <el-button style="float: right; padding: 3px 0;" type="text" @click="togglePhdRegistration">
        Κλείσιμο
      </el-button>
    </div>
    <div class="buttons">
      <el-button type="primary" icon="el-icon-refresh"
        :loading="refreshingList" :disabled="waiting"
        @click="refreshLists"
      >
        Ενημέρωση
      </el-button>
    </div>
    <div class="to-register-title">
      Διδακτορικά προς καταχώριση στο ΕΑΔΔ
    </div>
    <div>
      <el-table
        :data="phdRegistrationList"
        :default-sort="registrationListSort"
        style="width: 100%"
        :header-cell-style="{ 'padding': '12px 0' }"
        :cell-style="{ 'padding': '12px 0' }"
      >
        <el-table-column label="Καταχώριση" width="105" align="center">
          <template slot-scope="scope">
            <el-popover placement="right" v-model="scope.row.confirmVisible">
              <div class="dialog-text">
                Καταχώριση της αίτησης στο ΕΑΔΔ?<br>
                <span class="strong-text">{{ scope.row.appId }}: {{ scope.row.fullName }}</span>
              </div>
              <div class="dialog-buttons">
                <el-button size="mini" @click="scope.row.confirmVisible = false">
                  Ακύρωση
                </el-button>
                <el-button size="mini" type="primary" @click="registerApp(scope.row)">
                  Συνέχεια
                </el-button>
              </div>
              <el-button slot="reference"
                type="success" size="mini" icon="el-icon-upload2"
                :loading="scope.row.loading" :disabled="waiting"/>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="appId" label="Αρ. αίτησης" width="130" align="center" sortable/>
        <el-table-column prop="fullName" label="Ονοματεπώνυμο" width="300" sortable/>
        <el-table-column prop="protocol" label="Αρ. Πράξης" width="140" align="center" sortable/>
        <el-table-column prop="applicationTime" label="Οριστική υποβολή" width="172" align="center"
          :render-header="renderApplicationHeader" sortable/>
        <el-table-column width="50" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.appId + ': Τίτλος 3ου κύκλου σπουδών'"
              placement="top-start" effect="light">
              <el-button
                type="text" size="medium" icon="el-icon-document" :disabled="waiting"
                @click="showAttachment(scope.row.appId, scope.row.diplomaFileId)"/>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.appId + ': Δήλωση συναίνεσης'"
              placement="top-start" effect="light">
              <el-button
                type="text" size="medium" icon="el-icon-document" :disabled="waiting"
                @click="showAttachment(scope.row.appId, scope.row.consentFileId)"/>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="recognitionTime" label="Ψηφιακή υπογραφή" width="172" align="center"
          :render-header="renderRecognitionHeader" sortable/>
        <el-table-column width="50" align="center">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.appId + ': Πράξη αναγνώρισης'"
              placement="top-start" effect="light">
              <el-button
                type="text" size="medium" icon="el-icon-document" :disabled="waiting"
                @click="showAttachment(scope.row.appId, scope.row.praxiFileId)"/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <div>
        <el-button style="float: right; padding: 15px 0px;" type="text"
          :icon="moreIcon"
          @click="registeredPhdsDisplayed = !registeredPhdsDisplayed"/>
      </div>
      <div class="registered-title" v-if="registeredPhdsDisplayed">
        Καταχωρηθέντα Διδακτορικά στο ΕΑΔΔ (από την εφαρμογή eDoatap)
      </div>
      <div v-if="registeredPhdsDisplayed">
        <el-table
          :data="registeredPhdsList"
          :default-sort="registeredSort"
          style="width: 100%"
          :header-cell-style="{ 'padding': '12px 0' }"
          :cell-style="{ 'padding': '12px 0' }"
        >
          <el-table-column label="Διαγραφή" width="105" align="center" v-if="debug">
            <template slot-scope="scope">
              <el-button
                type="danger" size="mini" icon="el-icon-delete"
                :loading="scope.row.loading" :disabled="waiting"
                @click="deleteRegistration(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="eaddId" label="ΕΑΔΔ ID" width="100" align="center" sortable/>
          <el-table-column prop="registrationTime" label="Καταχώριση" width="160" align="center" sortable/>
          <el-table-column prop="appId" label="Αρ. αίτησης" width="130" align="center" sortable/>
          <el-table-column prop="fullName" label="Ονοματεπώνυμο" width="300" sortable/>
          <el-table-column prop="protocol" label="Αρ. Πράξης" width="140" align="center" sortable/>
          <el-table-column prop="recognition" label="Αναγνώριση" width="130" align="center" sortable/>
        </el-table>
      </div>
    </div>
  </el-card>
</template>

<script>
import axios from 'axios'
import config from '../../config.js'
import sharedMethods from '../common/sharedMethods.js'

// Applications recognized (digitally signed) on and before this date was manually registered,
// therefore are excluded from the list
const registrationListExclusionDateTo = '30-11-2023' // d-mm-yyyy format

export default {
  mixins: [sharedMethods],
  data () {
    return {
      debug: false,
      returnedList: [],
      returnedRegisteredPhds: [],
      registrationListSort: {
        prop: 'appId',
        order: 'ascending'
      },
      registeredSort: {
        prop: 'eaddId',
        order: 'descending'
      },
      refreshingList: false,
      registeringPhd: false,
      refreshingRegistered: false,
      deletingRegistration: false,
      registeredPhdsDisplayed: false
    }
  },
  methods: {
    renderApplicationHeader (h, { column }) {
      return <el-tooltip effect="light" placement="top">
      <template slot="content">
        Ημερομηνία πρώτης οριστικής υποβολής<br/>
        της αίτησης από τον πολίτη
      </template>
      <span>{ column.label }</span>
      </el-tooltip>
    },
    renderRecognitionHeader (h, { column }) {
      return <el-tooltip effect="light" placement="top">
      <template slot="content">
        Ημερομηνία ολοκλήρωσης της αναγνώρισης (ψηφιακής<br/>
        υπογραφής του εγγράφου) από τον πρόεδρο
      </template>
      <span>{ column.label }</span>
      </el-tooltip>
    },
    togglePhdRegistration () {
      this.$store.dispatch('SHOW_HIDE_PHD_REGISTRATION')
    },
    refreshLists () {
      this.getPhdRegistrationList()
      if (this.registeredPhdsDisplayed) {
        this.getRegisteredPhds()
      }
    },
    getPhdRegistrationList () {
      this.refreshingList = true
      this.returnedList = []
      const url = `${config.BASE_URL}/phd_registry/get_phds_to_register?startDate=${registrationListExclusionDateTo}`
      axios.get(url)
        .then(response => {
          if (response.data.success) {
            this.returnedList = response.data.data
          } else {
            this.frontEndError(response.data.message.text[0])
          }
        })
        .catch(err => {
          this.frontEndError(err.response.data.message.text[0])
        })
        .then(response => {
          this.refreshingList = false
        })
    },
    registerApp (row) {
      row.confirmVisible = false
      row.loading = true
      this.registeringPhd = true

      const url = `${config.BASE_URL}/phd_registry/${row.appId}/create/true`
      axios.post(url)
        .then(response => {
          if (response.data.success) {
            this.frontEndSuccessMsg('Τα στοιχεία καταχωρήθηκαν με επιτυχία!')
            this.refreshLists()
          } else {
            this.frontEndError(response.data.message.text[0])
          }
        })
        .catch(err => {
          var msg = err ? err.response.data.message.text[0] : 'Υπήρξε σφάλμα κατά την αποστολή των στοιχείων.'
          if (msg === 'Problem with fields: email') {
            msg = 'Παρουσιάστηκε πρόβλημα με το email (διπλότυπο). Παρακαλώ επικοινωνήστε με το ΕΑΔΔ-ΕΚΤ.'
          }
          this.frontEndError(msg)
        })
        .then(response => {
          row.loading = false
          this.registeringPhd = false
        })
    },
    getRegisteredPhds () {
      this.refreshingRegistered = true
      this.returnedRegisteredPhds = []
      const url = `${config.BASE_URL}/phd_registry/get_all`
      axios.get(url)
        .then(response => {
          if (response.data.success) {
            this.returnedRegisteredPhds = response.data.data
          } else {
            this.frontEndError(response.data.message.text[0])
          }
        })
        .catch(err => {
          if (this.registeredPhdsDisplayed) {
            this.frontEndInfoMsg(err.response.data.message.text[0])
          }
        })
        .then(response => {
          this.refreshingRegistered = false
        })
    },
    deleteRegistration (row) {
      row.loading = true
      this.deletingRegistration = true

      const url = `${config.BASE_URL}/phd_registry/${row.appId}/delete`
      axios.delete(url)
        .then(response => {
          if (response.data.success) {
            this.frontEndSuccessMsg('Η εγγραφή διαγράφηκε με επιτυχία')
            this.refreshLists()
          } else {
            this.frontEndError(response.data.message.text[0])
          }
        })
        .catch(err => {
          const msg = err ? err.response.data.message.text[0] : 'Υπήρξε σφάλμα κατά την διαγραφή.'
          this.frontEndError(msg)
        })
        .then(response => {
          row.loading = false
          this.deletingRegistration = false
        })
    },
    showAttachment (appId, docId, title) {
      axios.get(`${config.BASE_URL}/users/uid/applications/${appId}/attachments/${docId}`)
        .then((response) => {
          const fileData = response.data.data
          const base64Data = encodeURI(fileData.file[0])
          const tabTitle = fileData.doc_info.name + ' (' + fileData.doc_info.id + ')'
          this.openPdfWindow(title || tabTitle, base64Data)
        })
    }
  },
  computed: {
    phdRegistrationList () {
      return this.returnedList.map((app) => ({
        loading: false,
        confirmVisible: false,
        appId: app.id,
        fullName: app.lastname + ' ' + app.firstname,
        protocol: app.act_no,
        applicationTime: app.submitted_at.date.substr(0, 19),
        recognitionTime: app.digital_signed_date ? app.digital_signed_date.substr(0, 19) : '',
        consentFileId: app.consent_file_id,
        diplomaFileId: app.diploma_file_id,
        praxiFileId: app.praxi_file_id
      }))
    },
    registeredPhdsList () {
      return this.returnedRegisteredPhds.map((app) => ({
        loading: false,
        eaddId: app.id,
        registrationTime: app.created_at,
        appId: app.app_id,
        fullName: app.lastname + ' ' + app.firstname,
        protocol: app.act_no,
        recognition: app.rec_year + '/' + app.rec_month
      }))
    },
    waiting () {
      return this.refreshingList || this.registeringPhd ||
        this.deletingRegistration || this.refreshingRegistered
    },
    moreIcon () {
      return this.registeredPhdsDisplayed ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
    }
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  margin-top: 30px;
  margin-bottom: 10px;
  padding-bottom: 10px;
}

.to-register-title {
  padding-top: 10px;
  border-bottom: 1px solid #ebeef5;
}

.registered-title {
  padding-top: 50px;
  border-bottom: 1px solid #ebeef5;
}

.el-table {
  margin-top: 10px;
}

.el-table .cell {
  line-height: 23px;
}

.el-input {
  width: 200px
}

.dialog-text {
  padding: 0px 40px;
  padding-bottom: 10px;
  line-height: 1.7rem;
}

.strong-text {
  font-weight: bold;
}

.dialog-buttons {
  padding-top: 10px;
  margin-bottom: 5px;
  padding-right: 10px;
  text-align: right;
}

.bg-dark {
  background: #80c1ff;
}

.bg {
  background: #cce6ff;
}

.bg-light {
  background: #e6f3ff;
}

.el-form-item__label {
    text-align: right;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.el-form-item {
  color: rgb(30, 0, 128);
  font-weight: bold;
  padding-right: 20px;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PhdRegistration.vue